import { IsString } from "class-validator";
import ResponseEntity, { InputEntity } from "..";

export class UserOtpRegenerateInput extends InputEntity {
  constructor(public readonly action: string) {
    super();
  }
}

export class UserOtpValidateInput extends UserOtpRegenerateInput {
  constructor(action: string, public readonly otp: string) {
    super(action);
  }
}

export class UserOtpResponse extends ResponseEntity {
  @IsString() public readonly action!: string;
}